module.exports = __webpack_public_path__ + "img/slide2.0656d126.png";